//@flow
import React, { Component } from 'react'
/**
 * Default error component.
 * @memberof components
 */
class ErrorComponent extends Component {
  render() {
    return (
      <div>
        <p>
          An error occurred. Please click{' '}
          <a href="" onClick={() => (window.location = window.location)}>
            here
          </a>{' '}
          to refresh the quiz.
        </p>
      </div>
    )
  }
}

export default ErrorComponent



// WEBPACK FOOTER //
// ./src/components/ErrorComponent.js